// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file requests/v1/market_driven_status_update_request.proto (package requests.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file requests/v1/market_driven_status_update_request.proto.
 */
export const file_requests_v1_market_driven_status_update_request: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjVyZXF1ZXN0cy92MS9tYXJrZXRfZHJpdmVuX3N0YXR1c191cGRhdGVfcmVxdWVzdC5wcm90bxILcmVxdWVzdHMudjEiwwEKH01hcmtldERyaXZlblN0YXR1c1VwZGF0ZVJlcXVlc3QSQwoGc3RhdHVzGAEgASgOMjMucmVxdWVzdHMudjEuTWFya2V0RHJpdmVuU3RhdHVzVXBkYXRlUmVxdWVzdC5TdGF0dXMiWwoGU3RhdHVzEhYKElNUQVRVU19VTlNQRUNJRklFRBAAEhEKDVNUQVRVU19BQ1RJVkUQARITCg9TVEFUVVNfTUlHUkFURUQQAhIRCg1TVEFUVVNfTEVHQUNZEANCigEKD2NvbS5yZXF1ZXN0cy52MUIkTWFya2V0RHJpdmVuU3RhdHVzVXBkYXRlUmVxdWVzdFByb3RvUAFaBC4vcGKiAgNSWFiqAgtSZXF1ZXN0cy5WMcoCC1JlcXVlc3RzXFYx4gIXUmVxdWVzdHNcVjFcR1BCTWV0YWRhdGHqAgxSZXF1ZXN0czo6VjFiBnByb3RvMw'
    );

/**
 * @generated from message requests.v1.MarketDrivenStatusUpdateRequest
 */
export type MarketDrivenStatusUpdateRequest = Message<'requests.v1.MarketDrivenStatusUpdateRequest'> & {
    /**
     * @generated from field: requests.v1.MarketDrivenStatusUpdateRequest.Status status = 1;
     */
    status: MarketDrivenStatusUpdateRequest_Status;
};

/**
 * Describes the message requests.v1.MarketDrivenStatusUpdateRequest.
 * Use `create(MarketDrivenStatusUpdateRequestSchema)` to create a new message.
 */
export const MarketDrivenStatusUpdateRequestSchema: GenMessage<MarketDrivenStatusUpdateRequest> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_market_driven_status_update_request, 0);

/**
 * @generated from enum requests.v1.MarketDrivenStatusUpdateRequest.Status
 */
export enum MarketDrivenStatusUpdateRequest_Status {
    /**
     * @generated from enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,

    /**
     * @generated from enum value: STATUS_ACTIVE = 1;
     */
    ACTIVE = 1,

    /**
     * @generated from enum value: STATUS_MIGRATED = 2;
     */
    MIGRATED = 2,

    /**
     * @generated from enum value: STATUS_LEGACY = 3;
     */
    LEGACY = 3,
}

/**
 * Describes the enum requests.v1.MarketDrivenStatusUpdateRequest.Status.
 */
export const MarketDrivenStatusUpdateRequest_StatusSchema: GenEnum<MarketDrivenStatusUpdateRequest_Status> =
    /*@__PURE__*/
    enumDesc(file_requests_v1_market_driven_status_update_request, 0, 0);
